export default __webpack_public_path__ + "static/media/wPants_1_p4.0a344361.jpeg";